(function () {
  // Cantidad: botones + y -
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cantidad]');
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    var min = parseInt(input.min || '1', 10);
    var v = (parseInt(input.value, 10) || min) + parseInt(b.dataset.cantidad, 10);
    input.value = Math.max(min, v);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Carrito: guarda al cambiar cantidad
  document.querySelectorAll('[data-carrito]').forEach(function (form) {
    form.addEventListener('change', function (e) {
      if (e.target.matches('.cantidad input')) form.submit();
    });
  });

  // Filtros de la portada: categoría, precio y orden
  document.querySelectorAll('[data-catalogo]').forEach(function (raiz) {
    var grilla = raiz.querySelector('[data-grilla]');
    var tarjetas = Array.prototype.slice.call(raiz.querySelectorAll('[data-tarjeta]'));
    var vacio = raiz.querySelector('[data-vacio]');
    var chips = raiz.querySelectorAll('[data-categoria]');
    var precio = raiz.querySelector('[data-filtro-precio]');
    var orden = raiz.querySelector('[data-orden]');
    var categoria = '';
    var estado = raiz.querySelector('[data-estado]');
    var verTodos = raiz.querySelector('[data-ver-todos]');
    function aplicar() {
      var rango = precio && precio.value ? precio.value.split('-') : null;
      var visibles = 0;
      tarjetas.forEach(function (t) {
        var p = parseInt(t.dataset.precio, 10) || 0;
        var okCat = !categoria || (' ' + t.dataset.colecciones).indexOf(' ' + categoria + ' ') !== -1;
        var okPre = !rango || (p >= parseInt(rango[0], 10) && p <= parseInt(rango[1], 10));
        t.hidden = !(okCat && okPre) || (!categoria && !rango && t.hasAttribute('data-extra'));
        if (!t.hidden) visibles++;
      });
      if (vacio) vacio.hidden = visibles > 0;
      if (estado) estado.textContent = visibles === 1 ? '1 producto' : visibles + ' productos';
      var o = orden ? orden.value : '';
      var lista = tarjetas.slice();
      if (o === 'precio-asc') lista.sort(function (a, b) { return a.dataset.precio - b.dataset.precio; });
      if (o === 'precio-desc') lista.sort(function (a, b) { return b.dataset.precio - a.dataset.precio; });
      if (o === 'nuevos') lista.sort(function (a, b) { return b.dataset.fecha - a.dataset.fecha; });
      lista.forEach(function (t) { grilla.appendChild(t); });
    }
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        categoria = c.dataset.categoria;
        chips.forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
        if (verTodos) {
          verTodos.href = c.dataset.url || verTodos.dataset.url;
          verTodos.textContent = c.dataset.nombre ? 'Ver todo en ' + c.dataset.nombre : 'Ver todos los productos';
        }
        aplicar();
      });
    });
    if (precio) precio.addEventListener('change', aplicar);
    if (orden) orden.addEventListener('change', aplicar);
  });

  // Reels y videos
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-reproducir]');
    if (!b) return;
    var v = b.parentElement.querySelector('video');
    if (v) { v.controls = true; v.play(); b.remove(); }
  });

  // Galería del producto
  document.querySelectorAll('[data-galeria]').forEach(function (g) {
    var principal = g.querySelector('[data-principal] img');
    var botones = g.querySelectorAll('[data-foto]');
    function elegir(b) {
      if (!principal) return;
      principal.src = b.dataset.foto;
      principal.removeAttribute('srcset');
      principal.alt = b.dataset.alt || '';
      botones.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
    }
    botones.forEach(function (b) { b.addEventListener('click', function () { elegir(b); }); });
    g.elegirPorMedia = function (id) {
      botones.forEach(function (b) { if (b.dataset.media === String(id)) elegir(b); });
    };
  });

  // Variantes del producto
  document.querySelectorAll('[data-producto]').forEach(function (form) {
    var datos = JSON.parse(form.querySelector('[data-variantes]').textContent);
    var idCampo = form.querySelector('[name="id"]');
    var precio = document.querySelector('[data-precio-producto]');
    var boton = form.querySelector('[data-agregar]');
    form.addEventListener('change', function (e) {
      if (!e.target.matches('[data-opcion]')) return;
      var elegidas = Array.prototype.map.call(form.querySelectorAll('[data-opcion]:checked'), function (i) { return i.value; });
      var v = datos.find(function (x) { return x.options.join('|') === elegidas.join('|'); });
      var barraBoton = document.querySelector('[data-barra-boton]');
      var barraPrecio = document.querySelector('[data-barra-precio]');
      if (!v) {
        boton.disabled = true;
        boton.textContent = 'No disponible';
        if (barraBoton) { barraBoton.disabled = true; barraBoton.textContent = 'No disponible'; }
        return;
      }
      idCampo.value = v.id;
      precio.innerHTML = v.precio + (v.antes ? ' <s>' + v.antes + '</s>' : '');
      boton.disabled = !v.available;
      boton.textContent = v.available ? 'Agregar al carrito' : 'Agotado';
      if (barraBoton) { barraBoton.disabled = boton.disabled; barraBoton.textContent = boton.textContent; }
      if (barraPrecio) barraPrecio.textContent = v.precio;
      history.replaceState(null, '', location.pathname + '?variant=' + v.id);
      var g = document.querySelector('[data-galeria]');
      if (g && v.media && g.elegirPorMedia) g.elegirPorMedia(v.media);
    });
  });

  // Barra de compra en celular: aparece cuando el botón principal no está a la vista
  var barraCompra = document.querySelector('[data-barra-compra]');
  var botonPrincipal = document.querySelector('[data-agregar]');
  if (barraCompra && botonPrincipal && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      barraCompra.hidden = es[0].isIntersecting;
    }).observe(botonPrincipal);
  }

  // Menú en celular
  var menuBoton = document.querySelector('[data-menu-abrir]');
  if (menuBoton) {
    var menu = document.getElementById(menuBoton.getAttribute('aria-controls'));
    var alternarMenu = function (abrir) {
      menu.classList.toggle('abierto', abrir);
      if (abrir) document.documentElement.style.setProperty('--menu-top', Math.max(0, menuBoton.closest('.cabecera').getBoundingClientRect().bottom) + 'px');
      document.documentElement.classList.toggle('menu-abierto', abrir);
      menuBoton.setAttribute('aria-expanded', abrir ? 'true' : 'false');
      menuBoton.setAttribute('aria-label', abrir ? 'Cerrar menú' : 'Abrir menú');
    };
    menuBoton.addEventListener('click', function () { alternarMenu(!menu.classList.contains('abierto')); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('abierto')) { alternarMenu(false); menuBoton.focus(); }
    });
    document.addEventListener('click', function (e) {
      if (menu.classList.contains('abierto') && !e.target.closest('.cabecera')) alternarMenu(false);
    });
  }

  // Filtros del catálogo en celular
  document.querySelectorAll('[data-filtros-abrir]').forEach(function (b) {
    var panel = document.getElementById(b.getAttribute('aria-controls'));
    b.addEventListener('click', function () {
      var abierto = panel.classList.toggle('abierto');
      b.setAttribute('aria-expanded', abierto ? 'true' : 'false');
    });
  });

  // Carrito lateral
  var raizTienda = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var lateral = document.querySelector('[data-carrito-lateral]');
  if (lateral && typeof lateral.showModal === 'function' && !document.body.classList.contains('template-cart')) {
    var pintarCarrito = function (secciones) {
      if (!secciones || !secciones['cart-drawer']) return;
      var doc = new DOMParser().parseFromString(secciones['cart-drawer'], 'text/html');
      var nuevo = doc.querySelector('[data-lateral-contenido]');
      var actual = lateral.querySelector('[data-lateral-contenido]');
      if (!nuevo || !actual) return;
      actual.replaceWith(nuevo);
      var total = nuevo.dataset.total;
      var icono = document.querySelector('[data-abrir-carrito]');
      if (icono) {
        icono.setAttribute('aria-label', 'Carrito, ' + total + ' productos');
        var contador = icono.querySelector('.contador');
        if (total === '0') {
          if (contador) contador.remove();
        } else {
          if (!contador) {
            contador = document.createElement('span');
            contador.className = 'contador';
            contador.setAttribute('aria-hidden', 'true');
            icono.appendChild(contador);
          }
          contador.textContent = total;
        }
      }
    };
    var abrirCarrito = function () {
      if (!lateral.open) lateral.showModal();
      var cerrar = lateral.querySelector('[data-lateral-cerrar]');
      if (cerrar) cerrar.focus();
    };
    var avisar = function (form, texto) {
      var aviso = form.querySelector('.aviso-carrito');
      if (!aviso) {
        aviso = document.createElement('p');
        aviso.className = 'aviso aviso-carrito';
        aviso.setAttribute('role', 'alert');
        form.appendChild(aviso);
      }
      aviso.textContent = texto;
    };
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches('[data-producto], [data-rapida]')) return;
      e.preventDefault();
      var datos = new FormData(form);
      datos.append('sections', 'cart-drawer');
      datos.append('sections_url', location.pathname);
      form.setAttribute('aria-busy', 'true');
      fetch(raizTienda + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: datos })
        .then(function (r) {
          return r.json().then(function (j) { return { ok: r.ok, j: j }; });
        })
        .then(function (res) {
          if (!res.ok) { avisar(form, res.j.description || 'No pudimos agregar este producto. Inténtalo de nuevo.'); return; }
          var previo = form.querySelector('.aviso-carrito');
          if (previo) previo.remove();
          pintarCarrito(res.j.sections);
          abrirCarrito();
        })
        .catch(function () { form.submit(); })
        .finally(function () { form.removeAttribute('aria-busy'); });
    });
    document.addEventListener('click', function (e) {
      var enlace = e.target.closest('[data-abrir-carrito]');
      if (enlace) { e.preventDefault(); abrirCarrito(); return; }
      if (e.target === lateral || e.target.closest('[data-lateral-cerrar]')) { lateral.close(); return; }
      var boton = e.target.closest('[data-carrito-lateral] [data-linea]');
      if (!boton) return;
      boton.disabled = true;
      fetch(raizTienda + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(boton.dataset.linea), quantity: Number(boton.dataset.nueva), sections: 'cart-drawer', sections_url: location.pathname })
      })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          pintarCarrito(j.sections);
          var cerrar = lateral.querySelector('[data-lateral-cerrar]');
          if (cerrar) cerrar.focus();
        })
        .catch(function () { location.href = raizTienda + 'cart'; });
    });
  }

  // Buscador con sugerencias
  var busca = document.querySelector('[data-busca]');
  if (busca && typeof busca.showModal === 'function') {
    var campo = busca.querySelector('[data-busca-q]');
    var resultados = busca.querySelector('[data-busca-resultados]');
    var estadoBusca = busca.querySelector('[data-busca-estado]');
    var espera = null;
    var pedido = null;
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-abrir-busca]')) {
        e.preventDefault();
        busca.showModal();
        campo.focus();
        return;
      }
      if (e.target === busca || e.target.closest('[data-busca-cerrar]')) busca.close();
    });
    campo.addEventListener('input', function () {
      clearTimeout(espera);
      if (pedido) pedido.abort();
      var q = campo.value.trim();
      if (q.length < 2) { resultados.innerHTML = ''; estadoBusca.textContent = ''; return; }
      espera = setTimeout(function () {
        pedido = new AbortController();
        fetch(raizTienda + 'search/suggest?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=5&section_id=predictive-search', { signal: pedido.signal })
          .then(function (r) { if (!r.ok) throw new Error('sugerencias'); return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var bloque = doc.querySelector('[data-sugerencias]');
            if (!bloque) return;
            resultados.replaceChildren(bloque);
            var todos = bloque.querySelector('.busca__todos');
            if (todos) todos.addEventListener('click', function (ev) { ev.preventDefault(); busca.querySelector('form').submit(); });
            var n = Number(bloque.dataset.total);
            estadoBusca.textContent = n === 0 ? 'Sin resultados' : n === 1 ? '1 resultado' : n + ' resultados';
          })
          .catch(function (err) { if (err.name !== 'AbortError') resultados.innerHTML = ''; });
      }, 250);
    });
  }

  // Tira de categorías: pausar el movimiento
  document.querySelectorAll('[data-tira-pausa]').forEach(function (b) {
    b.addEventListener('click', function () {
      var pausada = b.closest('[data-tira]').classList.toggle('tira--pausada');
      b.setAttribute('aria-pressed', pausada ? 'true' : 'false');
      b.setAttribute('aria-label', pausada ? 'Reanudar movimiento' : 'Pausar movimiento');
    });
  });

  // Asistente de chat (demostración con respuestas predefinidas; no usa IA real)
  var asistente = document.querySelector('[data-asistente]');
  if (asistente) {
    var raiz = asistente.dataset.raiz || '/';
    var panel = asistente.querySelector('.asistente__panel');
    var abrirChat = asistente.querySelector('[data-asistente-abrir]');
    var registro = asistente.querySelector('[data-asistente-log]');
    var rapidas = asistente.querySelector('[data-asistente-rapidas]');
    var formChat = asistente.querySelector('[data-asistente-form]');
    var campoChat = formChat.querySelector('input');
    var iniciado = false;
    var col = function (h) { return raiz + 'collections/' + h; };
    var faq = { t: 'Ver preguntas frecuentes', u: raiz + '#preguntas' };
    var humano = { t: 'Escribir al equipo', u: raiz + 'pages/contact' };
    var respuestas = [
      { c: /despach|env[ií]o|entrega|demora|llega/i, r: 'La información de despacho está en nuestras preguntas frecuentes. Es gratis en compras superiores a $40.000; si no, verás el costo antes de pagar.', l: [faq] },
      { c: /pag|tarjeta|webpay|cuota/i, r: 'Los medios de pago están en nuestras preguntas frecuentes, y los verás todos al finalizar la compra.', l: [faq] },
      { c: /cambi|devol|garant|retracto/i, r: 'Revisa las condiciones en las preguntas frecuentes. Si tu caso es especial, escríbele al equipo con tu número de pedido.', l: [faq, humano] },
      { c: /persona|humano|equipo|contacto|ayuda/i, r: 'Claro. Déjale tu mensaje al equipo de CasaBien y te responderán.', l: [humano] },
      { c: /cocina|sart[eé]n|olla|bater[ií]a|utensilio/i, r: 'Te dejo la categoría Cocina, con sartenes, baterías y utensilios.', l: [{ t: 'Ver Cocina', u: col('cocina') }] },
      { c: /organiz|orden|frasco/i, r: 'Aquí tienes las ideas para ordenar tu casa.', l: [{ t: 'Ver Organización', u: col('organizacion') }] },
      { c: /habitaci|dormitorio|cama/i, r: 'Te dejo la categoría Habitación.', l: [{ t: 'Ver Habitación', u: col('habitacion') }] },
      { c: /ba[nñ]o|toalla/i, r: 'Te dejo la categoría Baño.', l: [{ t: 'Ver Baño', u: col('bano') }] },
      { c: /producto|buscar|comprar|categor/i, r: '¿Qué parte de tu casa quieres mejorar?', l: [{ t: 'Cocina', u: col('cocina') }, { t: 'Organización', u: col('organizacion') }, { t: 'Habitación', u: col('habitacion') }, { t: 'Baño', u: col('bano') }] }
    ];
    var sugeridas = ['Buscar un producto', 'Despacho', 'Medios de pago', 'Cambios y devoluciones', 'Hablar con una persona'];
    var agregarMensaje = function (quien, texto, enlaces) {
      var m = document.createElement('div');
      m.className = 'asistente__msj asistente__msj--' + quien;
      var p = document.createElement('p');
      p.textContent = texto;
      m.appendChild(p);
      (enlaces || []).forEach(function (e) {
        var a = document.createElement('a');
        a.href = e.u;
        a.textContent = e.t;
        m.appendChild(a);
      });
      registro.appendChild(m);
      registro.scrollTop = registro.scrollHeight;
    };
    var responder = function (texto) {
      agregarMensaje('yo', texto);
      rapidas.hidden = true;
      var escribiendo = document.createElement('div');
      escribiendo.className = 'asistente__msj asistente__msj--ia asistente__escribe';
      escribiendo.setAttribute('aria-label', 'La asistente está escribiendo');
      escribiendo.innerHTML = '<span></span><span></span><span></span>';
      registro.appendChild(escribiendo);
      registro.scrollTop = registro.scrollHeight;
      var hallada = respuestas.find(function (x) { return x.c.test(texto); });
      setTimeout(function () {
        escribiendo.remove();
        if (hallada) agregarMensaje('ia', hallada.r, hallada.l);
        else agregarMensaje('ia', 'Todavía estoy en modo de demostración y no tengo esa respuesta. El equipo de CasaBien sí puede ayudarte.', [humano]);
        rapidas.hidden = false;
      }, 700);
    };
    sugeridas.forEach(function (t) {
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = t;
      b.addEventListener('click', function () { responder(t); });
      rapidas.appendChild(b);
    });
    var alternarChat = function (abrir) {
      panel.hidden = !abrir;
      asistente.classList.toggle('asistente--abierto', abrir);
      abrirChat.setAttribute('aria-expanded', abrir ? 'true' : 'false');
      abrirChat.setAttribute('aria-label', abrir ? 'Cerrar chat con la asistente' : 'Abrir chat con la asistente');
      if (abrir) {
        if (!iniciado) {
          iniciado = true;
          agregarMensaje('ia', '¡Hola! Soy la asistente de CasaBien. ¿En qué te ayudo hoy?');
        }
        campoChat.focus();
      } else {
        abrirChat.focus();
      }
    };
    abrirChat.addEventListener('click', function () { alternarChat(panel.hidden); });
    asistente.querySelector('[data-asistente-cerrar]').addEventListener('click', function () { alternarChat(false); });
    panel.addEventListener('keydown', function (e) { if (e.key === 'Escape') alternarChat(false); });
    panel.addEventListener('click', function (e) {
      if (e.target.closest('a') && e.target.closest('a').hash) alternarChat(false);
    });
    formChat.addEventListener('submit', function (e) {
      e.preventDefault();
      var t = campoChat.value.trim();
      if (!t) return;
      campoChat.value = '';
      responder(t);
    });
  }

  // Barra superior: alterna los mensajes
  document.querySelectorAll('[data-oferta]').forEach(function (rotor) {
    var items = rotor.querySelectorAll('[data-oferta-item]');
    if (items.length < 2) return;
    var actual = 0;
    var detenido = false;
    rotor.addEventListener('mouseenter', function () { detenido = true; });
    rotor.addEventListener('mouseleave', function () { detenido = false; });
    rotor.addEventListener('focusin', function () { detenido = true; });
    rotor.addEventListener('focusout', function () { detenido = false; });
    setInterval(function () {
      if (detenido || document.hidden) return;
      items[actual].classList.remove('oferta__centro--activo');
      actual = (actual + 1) % items.length;
      items[actual].classList.add('oferta__centro--activo');
    }, 5000);
  });

  // Entradas al desplazar
  if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var piezas = document.querySelectorAll('.hero-txt > *, .beneficio, .cabeza, .seccion > .h-seccion, .filtros, .categoria, .tarjeta, .pack__texto > *, .reel, .boletin > *, .resena, .video-uso > *, .pie__nombre');
    document.documentElement.classList.add('mov');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('visto'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -6% 0px' });
    piezas.forEach(function (p) {
      var i = Array.prototype.indexOf.call(p.parentElement.children, p);
      p.setAttribute('data-rev', '');
      p.style.setProperty('--d', Math.min(i, 5) * 70 + 'ms');
      io.observe(p);
    });
  }
})();

/* articulo: indice y tablas */
(function () {
  var cuerpo = document.querySelector('[data-articulo]');
  if (!cuerpo) return;
  cuerpo.querySelectorAll('table').forEach(function (t) {
    var w = document.createElement('div');
    w.className = 'articulo__tabla';
    t.parentNode.insertBefore(w, t);
    w.appendChild(t);
  });
  var nav = document.querySelector('[data-indice]');
  var titulos = Array.prototype.slice.call(cuerpo.querySelectorAll('h2'));
  if (!nav || titulos.length < 2) return;
  var lista = nav.querySelector('ol');
  var enlaces = titulos.map(function (h, i) {
    if (!h.id) h.id = 'seccion-' + (i + 1);
    var li = document.createElement('li');
    var a = document.createElement('a');
    a.href = '#' + h.id;
    a.textContent = h.textContent;
    li.appendChild(a);
    lista.appendChild(li);
    return a;
  });
  nav.hidden = false;
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        enlaces.forEach(function (a) { a.removeAttribute('aria-current'); });
        var a = enlaces[titulos.indexOf(e.target)];
        if (a) a.setAttribute('aria-current', 'true');
      });
    }, { rootMargin: '0px 0px -75% 0px' });
    titulos.forEach(function (h) { io.observe(h); });
  }
})();

/* menu: categorias desplegables en celular */
(function () {
  document.querySelectorAll('.menu-grupo__abrir').forEach(function (b) {
    b.addEventListener('click', function () {
      var grupo = b.closest('[data-menu-grupo]');
      var abrir = !grupo.classList.contains('abierto');
      document.querySelectorAll('[data-menu-grupo].abierto').forEach(function (g) {
        g.classList.remove('abierto');
        g.querySelector('.menu-grupo__abrir').setAttribute('aria-expanded', 'false');
      });
      if (abrir) { grupo.classList.add('abierto'); b.setAttribute('aria-expanded', 'true'); }
    });
  });
})();

/* filtros de categoria */
(function () {
  var form = document.querySelector('form[data-filtros]');
  var raiz = document.querySelector('[data-filtros-raiz]');
  if (!form || !raiz) return;
  var panel = raiz.querySelector('[data-filtros-panel]');
  var abre = raiz.querySelector('[data-filtros-abre]');
  var alternar = function (abrir) {
    if (!panel) return;
    panel.classList.toggle('abierto', abrir);
    document.documentElement.classList.toggle('menu-abierto', abrir);
    if (abre) abre.setAttribute('aria-expanded', abrir ? 'true' : 'false');
  };
  if (abre) abre.addEventListener('click', function () { alternar(true); });
  var cierra = raiz.querySelector('[data-filtros-cerrar]');
  if (cierra) cierra.addEventListener('click', function () { alternar(false); if (abre) abre.focus(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && panel && panel.classList.contains('abierto')) { alternar(false); if (abre) abre.focus(); }
  });
  var enviar = function () {
    Array.prototype.forEach.call(form.elements, function (i) { if (i.type === 'number' && !i.value) i.disabled = true; });
    form.submit();
  };
  raiz.addEventListener('change', function (e) {
    if (e.target.form !== form) return;
    if (panel && panel.classList.contains('abierto') && panel.contains(e.target)) return;
    enviar();
  });
  form.addEventListener('submit', function () {
    Array.prototype.forEach.call(form.elements, function (i) { if (i.type === 'number' && !i.value) i.disabled = true; });
  });
})();

/* hero slider */
(function () {
  var hero = document.querySelector('[data-hero]');
  if (!hero) return;
  var slides = hero.querySelectorAll('[data-hero-slide]');
  var puntos = hero.querySelectorAll('[data-hero-punto]');
  var actual = 0;
  var mostrar = function (n) {
    actual = (n + slides.length) % slides.length;
    slides.forEach(function (s, i) {
      s.classList.toggle('hero-slide--activo', i === actual);
      s.toggleAttribute('hidden', i !== actual);
    });
    puntos.forEach(function (p, i) {
      if (i === actual) p.setAttribute('aria-current', 'true'); else p.removeAttribute('aria-current');
    });
  };
  puntos.forEach(function (p, i) { p.addEventListener('click', function () { mostrar(i); }); });
  var ant = hero.querySelector('[data-hero-ant]'), sig = hero.querySelector('[data-hero-sig]');
  if (ant) ant.addEventListener('click', function () { mostrar(actual - 1); });
  if (sig) sig.addEventListener('click', function () { mostrar(actual + 1); });
  var x = null;
  hero.addEventListener('touchstart', function (e) { x = e.touches[0].clientX; }, { passive: true });
  hero.addEventListener('touchend', function (e) {
    if (x === null) return;
    var d = e.changedTouches[0].clientX - x; x = null;
    if (Math.abs(d) > 40) mostrar(actual + (d < 0 ? 1 : -1));
  });
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var pausa = false;
  hero.addEventListener('mouseenter', function () { pausa = true; });
  hero.addEventListener('mouseleave', function () { pausa = false; });
  hero.addEventListener('focusin', function () { pausa = true; });
  hero.addEventListener('focusout', function () { pausa = false; });
  setInterval(function () { if (!pausa && !document.hidden) mostrar(actual + 1); }, 7000);
})();
